import './NodeLevelsCard.css';
import { cardTitle } from '../../assets/jss/wisene-material-dashboard-pro-react-types';
import { ClassNameMap } from '@material-ui/styles';
import { closeSweetAlertStyle } from '../../helpers/CustomStyles';
import { connect } from 'react-redux';
import { configureNode } from '../../stores/actions/nodeActions';
import Button from '../../../components/CustomButtons/ButtonTS';
import CancelIcon from '@material-ui/icons/Cancel';
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Card from '../../../components/Card/CardTS';
import CardHeader from '../../../components/Card/CardHeaderTS';
import CardIcon from '../../../components/Card/CardIcon.js';
import dashboardStyle from '../../assets/jss/views/dashboardStyleTS';
import Download from '@material-ui/icons/CloudDownload';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import React from 'react';
import styles from '../../assets/jss/views/dashboardStyle';
import { SYSTEM_VERSIONS } from '../../helpers/Systems';
import CardBody from '../../../components/Card/CardBody';
import LevelSlider from './LevelSlider';
import TextField from '@material-ui/core/TextField';
import { InputAdornment } from '@material-ui/core';
import { SENSORS } from '../../helpers/Devices';

const style = {
	cardTitle,
	cardCategory: styles.cardCategory,
};

interface IConfigNodeCardProps {
	configureNode: (
		nodeID: number,
		threshold: number,
		l1: number,
		l2: number,
		l3: number,
		l4: number,
		updatedViaWebsiteAt: string
	) => void;
	classes: ClassNameMap;
	hideAlert: () => void;
	mainSensorType: string;
	nodeID: number;
	nodeName: string;
	systemVersion: string;
	updatedViaWebsiteAt: string;
	threshold: number;
	l1: number;
	l2: number;
	l3: number;
	l4: number;
	inclinometerInverted: boolean;
	systemID: number;
}
interface Level {
	value: number | null;
	min: number;
	max: number;
	label: string;
	error: boolean;
}
interface IConfigNodeCardState {
	lock: boolean;
	mainSensorType: string;
	nodeID: number;
	nodeName: string;
	systemVersion: string;
	updatedViaWebsiteAt: string;
	ls: Array<Level>;
	threshold: string;
	thresholdError: boolean;
	inclinometerInverted: boolean;
}

class BaseNodeCard extends React.Component<IConfigNodeCardProps, IConfigNodeCardState> {
	constructor(props) {
		super(props);
		this.state = {
			lock: false,
			mainSensorType: this.props.mainSensorType,
			nodeID: this.props.nodeID,
			nodeName: this.props.nodeName,
			systemVersion: '',
			updatedViaWebsiteAt: this.props.updatedViaWebsiteAt,
			threshold: '' + (this.props.threshold ?? ''),
			thresholdError: false,
			inclinometerInverted: this.props.inclinometerInverted,
			ls: [
				{
					value: this.props.l1,
					min: 0,
					max: 100,
					label: 'L1',
					error: false,
				},
				{
					value: this.props.l2,
					min: 0,
					max: 100,
					label: 'L2',
					error: false,
				},
				{
					value: this.props.l3,
					min: 0,
					max: 100,
					label: 'L3',
					error: false,
				},
				{
					value: this.props.l4,
					min: 0,
					max: 100,
					label: 'L4',
					error: false,
				},
			],
		};
		this.recalculate = this.recalculate.bind(this);
		this.validate = this.validate.bind(this);
	}

	recalculate(val: number, label: string) {
		let levels = this.state.ls;
		levels.forEach((l) => {
			if (l.label === label) {
				l.value = val;
			}
		});
		console.log(levels);
		for (let i = 0; i < levels.length; i += 1) {
			levels[i].error = false;
			for (let j = levels.length - 1; j > i; j -= 1) {
				if (levels[i].value !== null && levels[j].value && (levels[i].value >= levels[j].value)) {
					levels[i].error = true;
				}
			}
		}
		this.setState({ ls: levels });
	}

	renderSliders() {
		return this.state.ls.map((l, idx) => (
			<LevelSlider
				key={`slider-levels-${idx}`}
				value={l.value}
				min={l.min}
				max={l.max}
				label={l.label}
				color={'info'}
				error={l.error}
				cBack={this.recalculate}
			/>
		));
	}
	renderInvertInclinometerCheckbox() {
		if (this.props.mainSensorType === SENSORS.Laser) {
			return null;
		} else {
			return (<FormControlLabel
				label="Inclinometer inverted"
				style={{color: 'rgba(53, 53, 53, 0.87)'}}
				control={
				<Checkbox
					style={{ color: 'rgb(0, 172, 193)' }}
					checked={this.state.inclinometerInverted}
					onChange={() => this.setState({inclinometerInverted: !this.state.inclinometerInverted})}
				/>
				}
			/>);
		}
	}

	validate(newThreshold: string) {
		if (this.state.mainSensorType === SENSORS.Iclinometer) {
			if (!newThreshold || !/^-?\d*\.?\d{0,3}$/.test(newThreshold)) {
				this.setState({ thresholdError: true });
				return;
			}
			const newThresholdValue = parseFloat(newThreshold);
			if (newThresholdValue > 4 || newThresholdValue < 0) {
				this.setState({ thresholdError: true });
			} else {
				this.setState({ thresholdError: false });
			}
		}

		if (this.state.mainSensorType === SENSORS.Laser) {
			if (!newThreshold || !/^\d+$/.test(newThreshold)) {
				this.setState({ thresholdError: true });
				return;
			}
			const newThresholdValue = parseInt(newThreshold);
			if (newThresholdValue > 1000 || newThresholdValue < 0) {
				this.setState({ thresholdError: true });
			} else {
				this.setState({ thresholdError: false });
			}
		}
	}

	handleClick() {
		const { threshold, ls, nodeID, inclinometerInverted } = this.state;
		const { systemID } = this.props;
		const l1 = ls[0].value ? ls[0].value : null;
		const l2 = ls[1].value ? ls[1].value : null;
		const l3 = ls[2].value ? ls[2].value : null;
		const l4 = ls[3].value ? ls[3].value : null;
		this.props.configureNode(nodeID, parseFloat(threshold), l1, l2, l3, l4, this.props.updatedViaWebsiteAt, inclinometerInverted, systemID);
		this.props.hideAlert();
	}

	render() {
		const {
			ls,
			nodeName,
			systemVersion,
			mainSensorType,
			threshold,
			thresholdError,
		} = this.state;
		const disableButton = ls.some((l) => l.error === true) || thresholdError;
		const units = mainSensorType === SENSORS.Iclinometer ? '°' : 'mm';

		// Prevent showing window for W2
		if (systemVersion === SYSTEM_VERSIONS.W2) {
			return <p>Option not available for W2 system version.</p>;
		}

		return (
			<ErrorComponent Children message='Something was wrong'>
				<GridContainer>
					<GridItem xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Button
							simple
							justIcon
							color='info'
							style={closeSweetAlertStyle}
							onClick={this.props.hideAlert}
							data-testid='cancelButton'
						>
							<CancelIcon style={{ width: '20px', height: '20px' }} />
						</Button>
					</GridItem>
				</GridContainer>

				<Card
					chart
					style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }}
					data-testid='exportCard'
				>
					<CardHeader color='info' icon>
						<CardIcon color='info'>
							<Download />
						</CardIcon>
						<p style={{ ...style.cardCategory, textAlign: 'left' }}>Threshold setting:</p>
						<h3 style={{ ...style.cardTitle, textAlign: 'left' }}>{nodeName}</h3>
					</CardHeader>
					<CardBody>
						<TextField
							id='name'
							error={thresholdError}
							inputProps={{ value: threshold }}
							InputProps={{
								endAdornment: <InputAdornment position='start'>{units}</InputAdornment>,
							}}
							onChange={(e) => {
								const { value } = e.target;
								this.validate(value);
								this.setState({ threshold: value });
							}}
                            onKeyDown={(e) => {
                                const key = e.key;
                                const value = e.target.value;
                                let allowedChars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 
                                            "Backspace", "Delete", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"];
                                if (mainSensorType === SENSORS.Iclinometer) {
                                    if (!value.length) {
                                        allowedChars.push('-');
                                    }
                                    if (value.indexOf(".") < 0 && value.length > 0 && value != "-")  {
                                        allowedChars.push('.');
                                        allowedChars.push(',');
                                    }
                                    if (/[,.][0-9]{3}/.test(value)) {
                                        allowedChars.splice(0, 10);
                                    }
                                }
                                if (allowedChars.indexOf(key) < 0) {
                                    e.preventDefault();
                                }
                            }}							style={{ marginTop: '15px', width: '70%' }}
							helperText={this.state.thresholdError ? 'Invalid value' : 'Numeric values only'}
						// className={error || settingNewNodeNameFailed ? 'showAnimation' : ''}
						></TextField>
						{this.renderSliders()}
						{this.renderInvertInclinometerCheckbox()}
						<GridItem xs={12} style={{ margin: '25px 0 0 0' }}>
							<Button
								color='info'
								onClick={() => this.handleClick()}
								disabled={disableButton}
								data-testid='thresholdButton'
								className='downloadButton'
							>
								Save
							</Button>
						</GridItem>
					</CardBody>
				</Card>
			</ErrorComponent>
		);
	}
}

const actions = { configureNode };

export const ExportCardWithStyles = dashboardStyle(BaseNodeCard);
export default connect(null, actions)(ExportCardWithStyles);
